<template>
  <!--==================
    component used in user login page
    ===============-->
  <div class="container-login100">
    <div class="wrap-login">
      <div class="wrap-login100">
        <div v-if="errorMessage" class="text-center text-danger mb-2 col"><em>email or password not correct</em></div>

        <form @submit.prevent="userLogin" ref="userForm" class="login100-form validate-form">
          <div class="login100-form-logo">
            <img src="@/assets/images/logo.png" />
          </div>

          <div class="wrap-input100 validate-input">
            <input
              class="input100"
              type="email"
              name="email"
              v-model="form.email"
              placeholder="Email"
              :disabled="submitForm"
              required
            />
            <i class="zmdi zmdi-account focus-input"></i>
          </div>

          <div class="wrap-input100 validate-input">
            <input
              class="input100"
              type="password"
              name="password"
              v-model="form.pass"
              placeholder="Password"
              :disabled="submitForm"
              required
            />
            <i class="zmdi zmdi-lock focus-input"></i>
          </div>
          <div class="login100-form-links">
            <a class="txt1 m-b-20" href="/forgot-password">Forgot Password?</a>
          </div>

          <div class="container-login100-form-btn">
            <button class="login100-form-btn" :disabled="submitForm">
              <span v-if="!submitForm">LOGIN</span>
              <span v-if="submitForm" class="spinner-border spinner-border-sm" role="status"></span>
              <span v-if="submitForm" class="ml-2">Login...</span>
            </button>
          </div>
        </form>
      </div>
      <p>
        &copy; {{ footerYear }} Safari-Tz | By
        <a class="txt1" href="https://www.isaka.co.tz" target="_blank">Isaka Developer</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
@import "@/assets/vendor/login-v3/fonts/iconic/css/material-design-iconic-font.min.css";
@import "@/assets/vendor/login-v3/css/util.css";
@import "@/assets/vendor/login-v3/css/main.css";
</style>

<script>
import $ from "jquery";
import Cookies from "js-cookie";
import { Constants } from "../constants.js";
import { mapActions } from "vuex";

export default {
  name: "Login",

  data() {
    return {
      footerYear: null,
      form: {},
      submitForm: false,
      errorMessage: false,
    };
  },

  mounted() {
    document.title = "Login";
    this.getFooterYear();
    this.focusInput();
  },

  methods: {
    ...mapActions(["userAuth"]),

    getFooterYear() {
      const now = new Date();
      this.footerYear = now.format("yyyy");
    },

    async userLogin() {
      this.submitForm = true;
      this.errorMessage = false;

      const formData = new FormData(this.$refs.userForm);
      const inputs = Object.fromEntries(formData.entries());

      await this.userAuth(inputs).then((res) => {
        if (res.data.statusCode == 401) {
          this.submitForm = false;
          this.errorMessage = true;
        } else {


          console.log("22222222222222222222222222222");
          console.log(res.data);
          console.log("22222222222222222222222222222");


          const user = res.data.user;
          const token = res.data.token;

          Cookies.set(Constants.LOGIN_USER, JSON.stringify(user), { expires: 7 });
          Cookies.set(Constants.API_TOKEN, token, { expires: 1 });
          window.location.href = "/dashboard";
        }
      });
    },

    focusInput() {
      $(".input100").each(function () {
        $(this).on("blur", function () {
          if ($(this).val().trim() != "") {
            $(this).addClass("has-val");
          } else {
            $(this).removeClass("has-val");
          }
        });
      });
    },
  },
};
</script>
